const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate the contact form.
 *
 * @param {{name:string,email:string,phone:string,subject:string,message:string}} form
 * @returns {Object} map of field name -> error message (empty when valid)
 */
export function validateContactForm(form) {
  const errors = {};

  if (!form.name || form.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters.";
  }

  if (!form.email) {
    errors.email = "Email is required.";
  } else if (!EMAIL_REGEX.test(form.email.trim())) {
    errors.email = "Enter a valid email address.";
  }

  const digits = (form.phone || "").replace(/\D/g, "");
  if (!form.phone) {
    errors.phone = "Phone number is required.";
  } else if (digits.length < 10 || digits.length > 15) {
    errors.phone = "Phone must contain 10 to 15 digits.";
  }

  if (!form.subject || !form.subject.trim()) {
    errors.subject = "Subject is required.";
  }

  if (!form.message || form.message.trim().length < 10) {
    errors.message = "Message must be at least 10 characters.";
  }

  return errors;
}
